import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Context from 'managers/Context';
import Content from './content/Content';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import Dialog from 'components/ContextDialog';
import Button from 'components/Button';
import { SuccessAlert, WarningAlert } from 'components/alerts';
import '../style.scss';
import stylejs from './style.js';

const propTypes = {
    login: PropTypes.bool.isRequired,
};

const ConfigurationInterface = ({ active, onTouchTap }) => {
    return <span className="ic-settings-filled" onClick={onTouchTap} />;
};

const ContentDialog = ({ content }) => {
    return content;
};

const Alert = ({ info }) => {
    let renderContent = info ? (
        <SuccessAlert text="_Datos válidos" />
    ) : info === false ? (
        <WarningAlert text="_Datos no válidos." />
    ) : (
        <noscript />
    );
    return renderContent;
};

class ConfigurationDialog extends Component {
    constructor(props) {
        super(props);
        const { formData } = this.props;
        this.state = {
            model: formData,
            open: false,
            schema: formData.buildDynamicSchema(),
            starterModel: JSON.parse(JSON.stringify(formData)),
            newInfo: undefined,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.formData !== prevState.formData) {
            return {
                schema: nextProps.formData.buildDynamicSchema(),
            };
        }
        return null;
    }

    onChange = (field, value) => {
        let { model, schema } = this.state;
        let schemaField = undefined;
        schema.map((section) => {
            return section.tabFields.map((fields) => {
                if (fields.id === field) {
                    schemaField = fields;
                }
            });
        });

        switch (schemaField.dataType) {
            case 'text':
                if (model.form[field] !== value) {
                    model.form[field] = value;
                    this.setState({ model: model });
                }
                break;
            default:
                if (model.form[field] !== value) {
                    model.form[field] = value;
                    this.setState({ model: model });
                }
                break;
        }
    };

    onUpdate = () => {
        let { model, starterModel } = this.state;
        Context.settingsManager.setIntegrations(
            model.id,
            model,
            () => {},
            (error) => {},
        );
        model.compareModels(model.form, starterModel.form)
            ? this.setState({ newInfo: true })
            : this.setState({ newInfo: false });
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false, newInfo: undefined });
    };

    render() {
        let { formData, active } = this.props;
        const { schema, model, newInfo } = this.state;

        const actions = [
            <Button
                text={<Literal literal="action_cancel" />}
                onClick={this.handleClose}
                type="primary"
            />,
            <Button text={<Literal literal="action_activate" />} onClick={this.onUpdate} />,
        ];

        return (
            <div className="configuration-dialog">
                {model.readonly || (
                    <ConfigurationInterface active={active} onClick={this.handleOpen} />
                )}
                <Dialog
                    title={<Literal literal="label_integration_settings" />}
                    className="configuration-dialog-ui"
                    titleClassName="dialog-header"
                    titleStyle={stylejs.titleStyle}
                    bodyClassName="dialog-content"
                    bodyStyle={stylejs.bodyStyle}
                    actionsContainerClassName="dialog-footer"
                    actionsContainerStyle={stylejs.footerStyle}
                    style={{ zIndex: 2 }}
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                >
                    <i className="ic-close" onClick={this.handleClose} />
                    <Literal literal="helptext_integration_settings" />
                    <Alert info={newInfo} />
                    <Content model={model.form} schema={schema} onChange={this.onChange} />
                </Dialog>
            </div>
        );
    }
}

ConfigurationDialog.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        login: state.config.login,
    };
}

export default connect(mapStateToProps)(ConfigurationDialog);
